import React from 'react';
import { Shield, Eye, AlertTriangle, Lock, UserCheck, Heart } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


const safetyFeatures = [
  {
    id: 'safety-block',
    icon: Shield,
    title: 'Block & Report',
    description: 'Block any user instantly. Report inappropriate behavior directly from their profile. Our team reviews all reports.',
  },
  {
    id: 'safety-verify',
    icon: UserCheck,
    title: 'Profile Verification',
    description: 'Verified badge members have confirmed their identity. Look for the green Verified status on profiles.',
  },
  {
    id: 'safety-privacy',
    icon: Lock,
    title: 'Privacy Controls',
    description: 'Control who sees your profile. Your contact details are never shared without your explicit consent.',
  },
  {
    id: 'safety-guidelines',
    icon: Eye,
    title: 'Community Standards',
    description: 'JSN enforces strict community guidelines. Disrespectful, inappropriate, or deceptive behavior leads to removal.',
  },
  {
    id: 'safety-reminders',
    icon: AlertTriangle,
    title: 'Safety Reminders',
    description: 'Never share financial information. Meet in public for first introductions. Trust your instincts. Your safety matters.',
  },
  {
    id: 'safety-respect',
    icon: Heart,
    title: 'Respectful Connections',
    description: 'JSN is built on dignity and respect. Every member deserves to feel safe, valued, and treated with honesty.',
  },
];

export default function SafetySection() {
  return (
    <section id="safety" className="py-24 bg-background">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10 2xl:px-16">
        <div className="text-center mb-16 space-y-3">
          <div className="text-xs font-semibold tracking-widest uppercase text-accent">
            Your Safety First
          </div>
          <h2 className="section-header">Built on Trust & Safety</h2>
          <p className="text-muted-foreground text-lg max-w-xl mx-auto">
            JSN is committed to creating a safe, respectful space for all Kenyan diaspora singles.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5">
          {safetyFeatures?.map((feat) => {
            const Icon = feat?.icon;
            return (
              <div
                key={feat?.id}
                className="bg-card border border-border rounded-2xl p-6 card-hover group"
              >
                <div className="w-11 h-11 rounded-xl bg-accent/10 border border-accent/20 flex items-center justify-center mb-4 group-hover:bg-accent/20 transition-colors">
                  <Icon size={20} className="text-accent" />
                </div>
                <h3 className="font-semibold text-foreground mb-2">{feat?.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{feat?.description}</p>
              </div>
            );
          })}
        </div>

        <div className="mt-12 p-6 bg-card border border-primary/20 rounded-2xl max-w-3xl mx-auto text-center space-y-3">
          <AlertTriangle size={24} className="text-primary mx-auto" />
          <h3 className="font-semibold text-foreground">Important Safety Reminder</h3>
          <p className="text-sm text-muted-foreground leading-relaxed">
            JSN does not conduct background checks on members. Exercise caution and good judgment when meeting anyone online. Report suspicious profiles immediately. Never send money to someone you have not met in person.
          </p>
          <div className="flex justify-center gap-4 pt-2 text-xs text-muted-foreground">
            <a href="/safety" className="hover:text-primary transition-colors underline">Community Guidelines</a>
            <a href="/safety" className="hover:text-primary transition-colors underline">Privacy Policy</a>
            <a href="/safety" className="hover:text-primary transition-colors underline">Terms of Service</a>
          </div>
        </div>
      </div>
    </section>
  );
}